import { render, staticRenderFns } from "./saAsideNavItemDropdown.vue?vue&type=template&id=709b731a"
import script from "./saAsideNavItemDropdown.vue?vue&type=script&lang=js"
export * from "./saAsideNavItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./saAsideNavItemDropdown.vue?vue&type=style&index=0&id=709b731a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports